import {BULK_ANTIBODY_SCREEN} from 'bulk-workflows/antibody/BulkAntibodyConstants';
import {BULK_ASSEMBLY_SCREEN} from 'bulk-workflows/assembly/BulkAssemblyConstants';
import {BULK_TRANSLATION_SCREEN} from 'bulk-workflows/translation/BulkTranslationConstants';
import {MODEL_HUB_SCREEN} from 'model-hub/ModelHubConstants';
import * as NewUserFlowConstants from 'onboarding/new-user-flow/NewUserFlowConstants';
import * as RegistryActivationFlowConstants from 'onboarding/registry-activation-flow/RegistryActivationFlowConstants';
import * as OrganizationConstants from 'orgs/OrganizationConstants';
import * as TenantAdminConstants from 'tenants/admin/TenantAdminConstants';

export const LOADING_SCREEN = 'LOADING_SCREEN';

export const ALL_SCREENS = [
  ...NewUserFlowConstants.ALL_SCREENS,
  ...RegistryActivationFlowConstants.ALL_SCREENS,
  ...OrganizationConstants.ALL_SCREENS,
  ...TenantAdminConstants.ALL_SCREENS,
  MODEL_HUB_SCREEN,
  LOADING_SCREEN,
  BULK_ANTIBODY_SCREEN,
  BULK_ASSEMBLY_SCREEN,
  BULK_TRANSLATION_SCREEN,
] as const;

export type Screen = (typeof ALL_SCREENS)[number];

export function isInScreenSubset<TSub extends TSuper, TSuper>(
  screen: TSuper,
  subsetCollection: ReadonlyArray<TSub>
): screen is TSub {
  return subsetCollection.includes(screen as TSub);
}

export function isScreen(screen: string): screen is Screen {
  // @ts-expect-error `.includes` here expects `screen` is already included; we are explicitly trying to
  // narrow here
  return ALL_SCREENS.includes(screen);
}
